export default {plugin:{algolia:{ui:{search_by:'Search by'}}}};